const initialState = {
    jobList: [],
    isFetchingJob: false,
    isAddingJob: false,
    isAddingDocumentType: false,
    documentTypeList: [],
    isFetchingDocumentType: false,
    jobWithIdList: [],
    isFetchingJobWithId: false,
    isFetchingJobReport: false,
    jobReport: [],
};

const JobReducer = (state = initialState, action) => {
    switch (action.type) {
        case "REQUEST_ADD_JOB":
            return { ...state, isAddingJob: true };
        case "SUCCESS_ADD_JOB":
            return { ...state, jobList: action.payload, isAddingJob: false };
        case "ERROR_ADD_JOB":
            return { ...state }


        case "REQUEST_GET_JOB":
            return { ...state, isFetchingJob: true };
        case "SUCCESS_GET_JOB":
            return { ...state, jobList: action.payload.data, isFetchingJob: false };
        case "ERROR_GET_JOB":
            return { ...state, isFetchingJob: false };


        case "REQUEST_ADD_DOCUMENT_TYPE":
            return { ...state, isAddingDocumentType: true };
        case "SUCCESS_ADD_DOCUMENT_TYPE":
            return { ...state, documentTypeList: action.payload, isAddingDocumentType: false };
        case "ERROR_ADD_DOCUMENT_TYPE":
            return { ...state };


        case "REQUEST_GET_DOCUMENT_TYPE":
            return { ...state, isFetchingDocumentType: true };
        case "SUCCESS_GET_DOCUMENT_TYPE":
            return { ...state, documentTypeList: action.payload.data, isFetchingDocumentType: false };
        case "ERROR_GET_DOCUMENT_TYPE":
            return { ...state, isFetchingJob: false };


        case "REQUEST_GET_JOB_WITH_ID":
            return { ...state, isFetchingJobWithId: true };
        case "SUCCESS_GET_JOB_WITH_ID":
            return { ...state, jobWithIdList: action.payload.data, isFetchingJobWithId: false };
        case "ERROR_GET_JOB_WITH_ID":
            return { ...state, isFetchingJobWithId: false };


        case "REQUEST_JOB_REPORT":
            return { ...state, isFetchingJobReport: true };
        case "SUCCESS_JOB_REPORT":
            return { ...state, jobReport: action.payload.data, isFetchingJobReport: false };
        case "ERROR_JOB_REPORT":
            return { ...state, isFetchingJobReport: false };


        case "CLEAR_JOB_REPORT":
            return { ...state, jobReport: [], };

        default:
            return state;
    }
};
export default JobReducer;